import React from 'react'
import { SxProps } from '@mui/material'

import { useAccountSettings } from 'redux/hooks/SignedInAccount'
import { useKeyMetric } from 'redux/hooks/KeyMetrics'
import { useTranslation } from 'language/translator'

import Box from 'components_new/atoms/Box'

import NavigationItem from 'components_new/molecules/NavigationItem'
import { useParams } from 'utils/hooks'

interface KeyMetricNavigationProps {
  sx?: SxProps
}

const KeyMetricNavigation = (props: KeyMetricNavigationProps) => {
  const { sx } = props
  const { t } = useTranslation()
  const { id } = useParams<{ id: string }>()

  const keyMetric = useKeyMetric(id)
  const { isAdmin } = useAccountSettings()
  const disabled = !keyMetric || !isAdmin

  return (
    <>
      <Box sx={sx}>
        <NavigationItem
          item={{
            activePattern: `/key-metrics/${id}`,
            href: `/key-metrics/${id}`,
            icon: { name: 'Image' },
            title: t('global', 'overview')
          }}
        />
        <NavigationItem
          item={{
            activePattern: `/key-metrics/${id}/resources*`,
            href: `/key-metrics/${id}/resources`,
            icon: { name: 'Resources' },
            title: t('global', 'resources')
          }}
        />
        <NavigationItem
          item={{
            activePattern: `/key-metrics/${id}/groups*`,
            href: `/key-metrics/${id}/groups`,
            icon: { name: 'Groups' },
            title: t('global', 'groups')
          }}
        />
        <NavigationItem
          item={{
            activePattern: `/key-metrics/${id}/settings*`,
            disabled: disabled,
            href: `/key-metrics/${id}/settings`,
            icon: { name: 'Settings' },
            title: t('global', 'settings')
          }}
        />
      </Box>
    </>
  )
}

export default KeyMetricNavigation
